<template>
<div>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="2">
            <b-form-select id="basicSelect" v-model="queryParams.searchType" :plain="true" :options="searchTypeOptions" :value="'all'"></b-form-select>
          </b-col>
          <b-col sm="6">
              <b-form-input v-model="queryParams.keyword" placeholder="" v-on:keyup="$event.keyCode === 13 ? findQA() : ''"></b-form-input>
          </b-col>
          <b-col sm="2" style="text-align: center;">
              <b-button variant="primary" style="width: 100%;" v-on:click="findQA()">검색</b-button>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>기간검색</strong></b-col>
          <b-col sm="2">
            <date-picker v-model="fullDateTmp"
                        type="date"
                        range
                        placeholder="조회기간 선택"
                        :lang="datepickerLang"
                        @change="handleDateRangeChange"
                        style="width: 100%;"
            />
          </b-col>
          <b-col sm="5">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>문의종류</strong></b-col>
          <b-col sm="2">
            <b-form-select id="basicSelect" v-model="queryParams.qaSearchType" :plain="true">
              <option value='all'>전체</option>
              <option :value="titems.item_code" v-for="(titems, idx) in qaSearchTypeOptions">{{titems.item_name}}</option>
            </b-form-select>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>회원종류</strong></b-col>
          <b-col sm="10" style="display: inline-flex;">
            <b-form-checkbox v-model="isCheckUserAuth" style="padding-right: 15px;" @change="allCheckUserAuth">전체</b-form-checkbox>
            <b-form-checkbox-group v-model="queryParams.userAuthSearchArr" @click.native="isCheckUserAuth = false">
                <template v-for="(item, index) in userAuthOptions">
                    <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
                </template>
            </b-form-checkbox-group>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>문의구분</strong></b-col>
          <b-col sm="10" style="display: inline-flex;">
            <b-form-checkbox v-model="isCheckPublicType" style="padding-right: 15px;" @change="allCheckPublicType">전체</b-form-checkbox>
            <b-form-checkbox-group v-model="queryParams.publicTypeSearchArr" @click.native="isCheckPublicType = false">
                <template v-for="(item, index) in publicTypeOptions">
                    <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
                </template>
            </b-form-checkbox-group>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>응답상태</strong></b-col>
          <b-col sm="10" style="display: inline-flex;">
            <b-form-checkbox v-model="isCheckStatus" style="padding-right: 15px;" @change="allCheckStatus">전체</b-form-checkbox>
            <b-form-checkbox-group v-model="queryParams.qaStatusSearchArr" @click.native="isCheckStatus = false">
                <template v-for="(item, index) in qaStatusOptions">
                    <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
                </template>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <!-- <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="drDeleteRows.length == 0">* 클릭 하시면 상세내역 페이지로 이동합니다.</span>
                <span style="color:#222222; font-weight:bold; font-size:15px" v-if="drDeleteRows.length > 0">선택된 데이터 : {{drDeleteRows.length}}</span> -->
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="4" class="my-1">
                <!-- <b-button variant="outline-danger" style="float:right" v-on:click="drNoticeDelete()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1' : 'mx-1'">삭제</b-button> -->
              </b-col>
              <b-col md="1" class="my-1">
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-col>
            </b-row>
          </b-col>

          <!-- 로딩 -->
          <b-col sm="12" class="pt-sm-1" v-show="listLoading">
            <b-row>
              <b-col sm="6"></b-col>
              <b-col sm="6" class="pt-5 pb-5">
                <PulseLoader color="#20a8d8"></PulseLoader>
              </b-col>
            </b-row>
          </b-col>


          <b-col sm="12" class="pt-sm-1" v-show="!listLoading">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :selectable="qaListSelect"
                  :select-mode="'multi'"
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="qnaRowSelected">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>
                  <template slot="rnum" slot-scope="data">
                    <div>{{data.item.rnum}}</div>
                  </template>
                  <template slot="qastatus_name" slot-scope="data">
                    <div>
                      <span :class="'badge badge-'+(data.item.qastatus == '1' ? 'primary' : data.item.qastatus == '2' ? 'success' : data.item.qastatus == '3' ? 'secondary' : '')" style="font-size:15px; color:#ffffff">
                        {{data.item.qastatus_name}}
                      </span>
                    </div>
                  </template>
                  <template slot="title" slot-scope="data">
                    <div>
                      <a href="javascript:void(0)" v-on:click="qaInfoGo(data.item)">{{data.item.title}}</a>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="10" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
import swal from 'sweetalert2';
import datepicker from 'jquery-ui/ui/widgets/datepicker.js'
import datetimepicker from "daterangepicker/daterangepicker.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { codeAPI } from '../../common/code.js';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
const moment = require("moment");

export default {
  components: {
    PulseLoader,
    DatePicker,
  },
  data() {
    return {
      listLoading: true,
      datepickerLang: {
          yearFormat: "YYYY년",
          monthFormat: "M월",
          days:["일","월","화","수","목","금","토"]
      },
      fullDateTmp: [],
      qaListSelect: false,
      userInfo:{},
      queryParams: {
        name: '',
        content: '',
        endDate: '',
        startDate: '',
        searchType: 'all',
        qaSearchType: 'all',
        qastatus:'0',
        userAuthSearchArr:[],   //회원종류
        publicTypeSearchArr:[], //문의구분
        qaStatusSearchArr:[],   //응답상태
      },
      searchTypeOptions: [
        {text:'전체', value:'all'},
        {text:'제목', value:'qa_name'},
        {text:'내용', value:'qa_contents'},
        {text:'작성자 명', value:'user_name'},
        {text:'작성자 아이디', value:'user_id'},
      ], // 상단 검색어 셀렉트 박스
      qaStatusOptions: [
        {item_name:'응대대기', item_code:'1'},
        {item_name:'응대완료', item_code:'2'},
        {item_name:'임시저장', item_code:'3'},
      ],
      userAuthOptions: [
        {item_name:'일반회원', item_code:'normal'},
        {item_name:'구독회원', item_code:'company'},
      ],
      publicTypeOptions: [
        {item_name:'회원', item_code:'user'},
        {item_name:'비회원', item_code:'public'},
      ],
      qaSearchTypeOptions: [],
      userAuthArr: {all:true},
      publicTypeArr: {all:true},
      isCheckUserAuth: false,   //회원종류 전체선택
      isCheckPublicType: false, //문의구분 전체선택
      isCheckStatus: false,     //응답상태 전체선택
      listRows: 0,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      fieldItems: [{
        // 'selectcheck': {
        //     'label': '선택',
        //     'class': 'text-center',
        //     'tdClass': 'text-vmiddle',
        //     'thStyle': {
        //       'vertical-align': 'middle'
        //     }
        //   }
        },{
          'rnum': {
            'label': '번호',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '100px'
            }
          }
        },{
          'qastatus_name': {
            'label': '상태',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '120px'
            }
          }
        },{
          'public_type_name': {
            'label': '문의구분',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '120px'
            }
          }
        }, {
          'type_name': {
            'label': '문의종류',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '120px'
            }
          }
        }, {
          'title': {
            'label': '제목',
            'class': 'text-left',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center'
            }
          }
        }, {
          'user_name': {
            'label': '작성자',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '120px'
            }
          }
        }, {
          'reg_date': {
            'label': '작성일',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '150px'
            }
          }
        }, {

        }
      ],
      items: [],
      deleteRows: [],
      qna_name: '',
      selectedQNA:{
        id:'',
        conn_id:'',
        title:'',
        reg_user:'',
        reg_date:'',
        check_yn:'',
        type_code:'',
        contents:'',
        user_name:'',
        join_date:'',
        mobile:'',
        type_name:'',
        reply:'',
        qastatus:'',
        qastatus_name:'',
        reply_date:'',
        reply_id:0,
        reply_reg_user:'',

      },
    }
  },
  watch: {
    'qaListSelect'(newId, oldId) {
      this.deleteRows = [];
    }
  },
  mounted: function() {
    var self = this;
    this.$store.dispatch('QNATOTALCNT', this); //고객문의관리 신규 문의 노출 확인
    self.userInfo = self.$session.get('userInfo');

    codeAPI.selectItemCodeList(self,"QA_TYPE",2,"qaSearchTypeOptions");

    // 최초 날짜 갱신(이번달)
    self.dateRange('this_month');
    // 최초 리스트 조회
    self.findQA();
  },
  methods: {
    qnaRowSelected(item, index, event){
      this.selectedQNA = item;
    },
    findQA() {
      this.listLoading = true;

      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/qaList?access_token=' + token, data, null)
        .then((result) => {
          console.log('qa data >>>',result.data);
          self.items = result.data;
          self.listRows = result.data.length;

          self.items.forEach(function (el, idx, arr){
            el.rnum = self.listRows - (idx);
            el.selectchecked = false;
          });
          this.listLoading = false;
      });
    },
    replyDelete(){
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.selectedQNA));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/delete/qaReply?access_token=' + token, data, null)
        .then((result) => {
          if(result.data == 'ok'){
            swal.fire({
              type: 'success',
              title: '답변을 삭제 했습니다.',
              showConfirmButton: false,
              timer: 1500
            })
            this.selectedQNA.qastatus = '1';
            this.selectedQNA.qastatus_name = '응대대기';
            this.selectedQNA.reply_date = '';
            this.selectedQNA.reply = '';
            this.selectedQNA.reply_id = null;
          }
      });
    },
    // 날짜 정의
    dateRange(flag) {
      let endDate = new Date();
      let startDate = new Date();

      if(flag == 'this_month'){
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
      }else if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
          this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
    handleDateRangeChange() {
      var self = this;
      if(self.fullDateTmp.length > 0){
        self.queryParams.startDate = moment(self.fullDateTmp[0]).format("YYYY-MM-DD");
        self.queryParams.endDate = moment(self.fullDateTmp[1]).format("YYYY-MM-DD");
      }else{
        self.queryParams.startDate = '';
        self.queryParams.endDate = '';
      }
    },
    qaInfoGo(row) {
      var self = this;
      self.$session.set('qaCode', row.id);
      self.$session.set('qaPublicTypeCode', row.public_type_code);
      location.href = '#/customer/qamanager/form';
    },

    //회원종류 전체선택 이벤트
    allCheckUserAuth(){
      this.isCheckUserAuth = !this.isCheckUserAuth;
        if(this.isCheckUserAuth) {
            this.queryParams.userAuthSearchArr = [];
            this.userAuthOptions.forEach((data) => {
                this.queryParams.userAuthSearchArr.push(data.item_code);
            });
        }else{
            this.queryParams.userAuthSearchArr = [];
        }
    },

    //문의구분 전체선택 이벤트
    allCheckPublicType(){
      this.isCheckPublicType = !this.isCheckPublicType;
        if(this.isCheckPublicType) {
            this.queryParams.publicTypeSearchArr = [];
            this.publicTypeOptions.forEach((data) => {
                this.queryParams.publicTypeSearchArr.push(data.item_code);
            });
        }else{
            this.queryParams.publicTypeSearchArr = [];
        }
    },

    //응답상태 전체선택 이벤트
    allCheckStatus(){
      this.isCheckStatus = !this.isCheckStatus;
        if(this.isCheckStatus) {
            this.queryParams.qaStatusSearchArr = [];
            this.qaStatusOptions.forEach((data) => {
                this.queryParams.qaStatusSearchArr.push(data.item_code);
            });
        }else{
            this.queryParams.qaStatusSearchArr = [];
        }
    },
  }
}
</script>

<style src="daterangepicker/daterangepicker.css"></style>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/QAManager.vue